export default __webpack_public_path__ + "static/media/email-newletter.58ae4069.svg";